export const AUDIO = 'audio';
export const VIDEO = 'video';
